import client from "../config/client"

import { WEB_API_URI } from "../config/api"
import { Dataset } from "../lib/types"

export async function getDatasetsAction(): Promise<Dataset[]> {
	return (await client(`${WEB_API_URI}/v1/dataset/all`)).data	
}

export async function getDatasetAction(dataset: string): Promise<Dataset[]> {
	return (await client(`${WEB_API_URI}/v1/dataset/${dataset}`)).data	
}